// import React from "react";

// const HomePageShimer = () => {
//   return (
//     <div className="h-[92vh] w-[100%] flex">
//       {/* side bar */}
//       <div className="w-[12%]" />
//       <div className="relative w-[76%] h-[92vh] bg-red-500">
//         <div className="absolute bg-grey-500 bottom-0 z-[44]">hello</div>
//       </div>
//       <div className="w-[12%]" />
//     </div>
//   );
// };

// export default HomePageShimer;

import React from "react";

const shimmer =
  "animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]";

const HomePageShimmer = () => {
  return (
    <div className="h-[92vh] w-full flex">
      {/* Sidebars */}
      <div className="w-[12%]" />
      <div className="relative w-[76%] h-[92vh] flex items-center justify-center">
        {/* Main 500x500 shimmer box */}
        <div
          className={`${shimmer} w-[500px] h-[550px] rounded-lg shadow-md mb-4`}
        ></div>

        {/* Absolute shimmer bar at bottom */}
        <div
          className={`${shimmer} absolute bottom-6 left-1/2 -translate-x-1/2 w-[50%] h-[50px] rounded-md shadow-sm`}
        ></div>
      </div>
      <div className="w-[12%]" />
    </div>
  );
};

export default HomePageShimmer;
